import { Sparkles } from "lucide-react";

const ITEMS = [
  "Authentic Quality Fireworks",
  "Cash on Delivery",
  "Eco Green Crackers",
  "Doorstep Express Delivery",
  "Fresh Stock",
  "Trusted by Families",
];

function Run() {
  return (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="px-7 font-display text-lg sm:text-2xl tracking-[0.14em] uppercase text-ember/70 whitespace-nowrap">
            {item}
          </span>
          <Sparkles className="h-4 w-4 shrink-0 text-crimson/70" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="relative border-y border-ember/15 bg-card/40 py-5 overflow-hidden" data-testid="marquee-band">
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        <Run />
        <div aria-hidden="true">
          <Run />
        </div>
      </div>
    </div>
  );
}
